import { ViewLayout } from '@/components/Layout'

const otherRoutes = [
  {
    // 首页
    path: '/index',
    name: 'index',
    meta: { title: '首页' },
    component: () => import('@/views/home/index')
  },
  {
    // 产品与服务
    path: '/products-services',
    name: 'products-services',
    meta: { title: '产品技术' },
    component: () => import('@views/productsServices/index.vue')
  },
  {
    // 解决方案
    path: '/solution',
    name: 'solution',
    meta: { title: '解决方案' },
    component: () => import('@views/smartcity/index.vue')
  },
  {
    // 生态价值
    path: '/ecological-value',
    name: 'ecological-value',
    meta: { title: '零碳海洋' },
    component: () => import('@views/ecologicalValue/index.vue')
  },
  {
    // 应用市场
    path: '/application-market',
    name: 'application-market',
    meta: { title: '工业节能' },
    component: () => import('@views/applicationMarket/index.vue')
  },
  {
    // 资环行动-公司新闻
    path: '/zh-action',
    name: 'zh-action',
    meta: { title: '公司新闻' },
    component: () => import('@views/zhAction/index.vue')
  },
  {
    // 资环行动-公司新闻详情
    path: '/newsDetail',
    name: 'newsDetail',
    meta: { title: '新闻详情' },
    component: () => import('@views/zhAction/newsDetail.vue')
  },
  {
    // 资环行动-行业资讯
    path: '/zh-information',
    name: 'zh-information',
    meta: { title: '行业资讯' },
    component: () => import('@views/zhInformation/index.vue')
  },
  {
    // 资环行动-行业资讯
    path: '/informationDetail',
    name: 'informationDetail',
    meta: { title: '行业资讯详情' },
    component: () => import('@views/zhInformation/informationDetail.vue')
  },
  {
    // 走进资环-视频新闻
    path: '/video',
    name: 'video',
    meta: { title: '视频新闻' },
    component: () => import('@views/walkintoZh/videoList.vue')
  },
  {
    // 视频新闻详情
    path: '/videoDetails',
    name: 'videoDetails',
    meta: { title: '视频新闻详情' },
    component: () => import('@views/walkintoZh/videoDetail.vue')
  },
  {
    // 详情
    path: '/details',
    name: 'details',
    meta: { title: '详情' },
    component: () => import('@views/walkintoZh/details.vue')
  },
  {
    // 公司概况
    path: '/walkinto-zh',
    name: 'walkinto-zh',
    meta: { title: '公司概况' },
    component: () => import('@views/walkintoZh/index.vue')
  },
  {
    // 技术产品
    path: '/coreValuese-zh',
    name: 'coreValuese-zh',
    meta: { title: '技术产品' },
    component: () => import('@views/walkintoZh/coreValuese.vue')
  },
  {
    // 资质荣誉
    path: '/honor-zh',
    name: 'honor-zh',
    meta: { title: '资质荣誉' },
    component: () => import('@views/walkintoZh/honor.vue')
  },
  {
    // 成果案例详情
    path: '/caseDetails',
    name: 'caseDetails',
    meta: { title: '成果案例详情' },
    component: () => import('@views/walkintoZh/caseDetails.vue')
  },
  {
    // 成果案件
    path: '/project-zh',
    name: 'project-zh',
    meta: { title: '成果案件' },
    component: () => import('@views/walkintoZh/project.vue')
  },
  {
    // 联系我们
    path: '/contact-us',
    name: 'contact-us',
    meta: { title: '联系我们' },
    component: () => import('@views/contactUs/index.vue')
  },
  {
    // 插入尾部
    path: '/footer',
    name: 'footer',
    component: () => import('@/views/components/footer.vue')
  },
  {
    path: '/error',
    name: 'error',
    redirect: '404',
    component: ViewLayout,
    children: [
      {
        path: '404',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/error/404')
      }
    ]
  }
]

export const appRoutes = [
  {
    // 首页
    path: '/index',
    name: 'index',
    meta: { title: '首页' },
    component: () => import('@/views/home/index')
  }
]

const routes = [...otherRoutes, ...appRoutes]

export default routes
